module.exports = __webpack_public_path__ + "static/media/carroll_alex-resume.0d20c3fb.pdf";